module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.boxConfig.trigger_button.kind === 'external') ? _c('div', {
    staticClass: "klick-modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "font-size": "30px",
      "color": "#6B8A99"
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "#6B8A99",
      "font-weight": "bold",
      "margin-top": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.external_button')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('h4', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('general.labels.step')) + " 1:")]), _vm._v(" " + _vm._s(_vm.$t('edit.canvas.click_button')) + " "), _c('b', [_vm._v(_vm._s(_vm.$t('general.actions.export')) + " "), _c('i', {
    staticClass: "kp-panel-import"
  })]), _vm._v(".")])]), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('general.labels.step')) + " 2:")]), _vm._v(" " + _vm._s(_vm.$t('edit.canvas.copy_the')) + " "), _c('b', [_vm._v(_vm._s(_vm.$t('edit.canvas.box_code')))]), _vm._v(" " + _vm._s(_vm.$t('edit.canvas.past_in_your_page')) + ".")])]), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('general.labels.step')) + " 3:")]), _vm._v(" " + _vm._s(_vm.$t('edit.canvas.copy_the')) + " "), _c('b', [_vm._v(_vm._s(_vm.$t('edit.canvas.call_button_code')))]), _vm._v(" " + _vm._s(_vm.$t('edit.canvas.add_to_link_or_button')) + ".")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-b2d2262e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/triggerbutton/External.vue
 ** module id = 902
 ** module chunks = 1
 **/